import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ad6b1cd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "breakdown-card"
};
const _hoisted_2 = {
  class: "breakdown-title"
};
const _hoisted_3 = {
  class: "breakdown-label"
};
const _hoisted_4 = {
  class: "breakdown-value"
};
const _hoisted_5 = {
  key: 1,
  class: "empty-detail"
};
const _hoisted_6 = {
  class: "card-amount"
};
const _hoisted_7 = {
  key: 1
};
import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { breakdown } from '@/api/settlement';
import { formatListAmount, rowKey } from './model';
import { checked } from './useSettlement';
export default /*#__PURE__*/_defineComponent({
  __name: 'SettlementAmount',
  props: {
    value: null,
    cardType: null,
    query: null,
    row: null
  },
  setup(__props) {
    const props = __props;
    const open = ref(false);
    const loading = ref(false);
    const error = ref('');
    const data = ref();
    const visibleGroups = computed(() => {
      var _data$value;
      return (((_data$value = data.value) === null || _data$value === void 0 ? void 0 : _data$value.groups) || []).map(group => ({
        ...group,
        items: group.items.filter(item => item.amount !== null && item.amount !== undefined && String(item.amount).trim() !== '')
      })).filter(group => group.items.length > 0);
    });
    let sequence = 0;
    let active = true;
    // BUG-011：日账单按月/总计的行周期可能为月份，必须传递账单类型和完整日期范围。
    async function openChange(value) {
      open.value = value;
      if (!value || !props.cardType || loading.value || data.value) return;
      const request = ++sequence;
      loading.value = true;
      error.value = '';
      const {
        market,
        billType,
        periods,
        startDate,
        endDate,
        statRange
      } = props.query;
      try {
        const result = await breakdown({
          market,
          billType,
          periods,
          startDate,
          endDate,
          statRange,
          rowKey: rowKey(props.row),
          cardType: props.cardType
        });
        if (active && request === sequence) data.value = checked(result);
      } catch (cause) {
        if (active && request === sequence) error.value = cause instanceof Error ? cause.message : '明细加载失败，请重试';
      } finally {
        if (active && request === sequence) loading.value = false;
      }
    }
    watch(() => [props.query, props.row, props.cardType], () => {
      sequence++;
      data.value = undefined;
      loading.value = false;
      error.value = '';
      open.value = false;
    });
    onBeforeUnmount(() => {
      active = false;
      sequence++;
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_popover = _resolveComponent("a-popover");
      return __props.cardType ? (_openBlock(), _createBlock(_component_a_popover, {
        key: 0,
        open: open.value,
        trigger: "hover",
        placement: "top",
        onOpenChange: openChange
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [loading.value ? (_openBlock(), _createBlock(_component_a_spin, {
          key: 0,
          size: "small"
        })) : error.value ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 1,
          type: "error",
          message: error.value,
          "show-icon": ""
        }, null, 8, ["message"])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [data.value && !data.value.accountReady ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 0,
          type: "info",
          message: "账号账单尚未就绪"
        })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleGroups), (group, index) => {
          var _group$items$;
          return _openBlock(), _createElementBlock("section", {
            key: index,
            class: "breakdown-group"
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(group.group === '收入明细' ? '结算收入明细' : group.group), 1), __props.cardType === 'tax' ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 0,
            color: (_group$items$ = group.items[0]) !== null && _group$items$ !== void 0 && _group$items$.inSettlement ? 'blue' : 'default'
          }, {
            default: _withCtx(() => {
              var _group$items$2;
              return [_createTextVNode(_toDisplayString((_group$items$2 = group.items[0]) !== null && _group$items$2 !== void 0 && _group$items$2.inSettlement ? '计入结算' : '不计入结算'), 1)];
            }),
            _: 2
          }, 1032, ["color"])) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, itemIndex) => {
            return _openBlock(), _createElementBlock("div", {
              key: itemIndex,
              class: "breakdown-item"
            }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatListAmount)(item.amount)), 1)]);
          }), 128))]);
        }), 128)), !_unref(visibleGroups).length ? (_openBlock(), _createElementBlock("span", _hoisted_5, "暂无明细")) : _createCommentVNode("", true)], 64))])]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatListAmount)(__props.value)), 1)]),
        _: 1
      }, 8, ["open"])) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(formatListAmount)(__props.value)), 1));
    };
  }
});